import { ImageState } from 'editor/src/store/gallery/types';
import { RootState } from 'editor/src/store/index';

import getSessionImages from './getSessionImages';

const getSessionUploadedImagesCount = (state: RootState) =>
  getSessionImages(state).filter((image) => image.state === ImageState.UPLOADED).length;

export default getSessionUploadedImagesCount;
